import { Pipe, PipeTransform } from '@angular/core';
import { flow } from 'lodash';

type UnaryFunction<T, R> = (arg: T) => R;

@Pipe({
  name: 'flow',
  standalone: true,
})
export class FlowPipe implements PipeTransform {
  transform<T>(value: T, fn1: UnaryFunction<T, T>): T;
  transform<T, A>(value: T, fn1: UnaryFunction<T, A>): A;
  transform<T, A, B>(
    value: T,
    fn1: UnaryFunction<T, A>,
    fn2: UnaryFunction<A, B>
  ): B;
  transform<T, A, B, C>(
    value: T,
    fn1: UnaryFunction<T, A>,
    fn2: UnaryFunction<A, B>,
    fn3: UnaryFunction<B, C>
  ): C;
  transform<T, A, B, C, D>(
    value: T,
    fn1: UnaryFunction<T, A>,
    fn2: UnaryFunction<A, B>,
    fn3: UnaryFunction<B, C>,
    fn4: UnaryFunction<C, D>
  ): D;
  public transform<T, R>(
    value: T,
    ...functions: Array<UnaryFunction<unknown, unknown>>
  ): R {
    return flow(functions)(value);
  }
}
